export default function ShareIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.12525 4.83326V2.33325L12.2501 6.458L8.12525 10.5828V7.7642M8.12525 4.83813C7.75005 4.75299 7.35957 4.70804 6.95858 4.70804C4.05912 4.70804 1.70862 7.05854 1.70862 9.958C1.70862 10.464 1.78021 10.9533 1.91382 11.4163C2.54577 9.22633 4.56515 7.62467 6.95858 7.62467C7.35957 7.62467 7.75005 7.66964 8.12525 7.75475"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
